/** Thrown when fetchInspectionTemplates is called without a usable building id. */
export class InvalidInspectionTemplatesBuildingIdError extends Error {
  constructor() {
    super(
      'fetchInspectionTemplates requires buildingId: a non-empty string (after trim)'
    );
    this.name = 'InvalidInspectionTemplatesBuildingIdError';
  }
}
